export default __webpack_public_path__ + "static/media/blue-circle.ab0edc73.svg";